import { FaApple, FaGooglePlay } from "react-icons/fa";

export const APP_STORE_URL = "https://apps.apple.com/app/id6744372880";
export const GOOGLE_PLAY_URL =
  "https://play.google.com/store/apps/details?id=com.vendororbis";

const stores = [
  {
    href: APP_STORE_URL,
    icon: FaApple,
    caption: "Download on the",
    store: "App Store",
  },
  {
    href: GOOGLE_PLAY_URL,
    icon: FaGooglePlay,
    caption: "Get it on",
    store: "Google Play",
  },
];

interface StoreButtonsProps {
  // "light" buttons sit on dark backgrounds, "glass" buttons blend into them.
  variant?: "light" | "glass";
  className?: string;
}

const StoreButtons = ({ variant = "light", className = "" }: StoreButtonsProps) => (
  <div className={`flex flex-wrap gap-3 ${className}`}>
    {stores.map(({ href, icon: Icon, caption, store }) => (
      <a
        key={store}
        href={href}
        target="_blank"
        rel="noopener noreferrer"
        aria-label={`${caption} ${store}`}
        className={`inline-flex items-center gap-3 rounded-2xl px-5 py-3 transition hover:-translate-y-0.5 ${
          variant === "light"
            ? "bg-white text-slate-900 hover:bg-slate-100"
            : "border border-white/15 bg-white/5 text-white hover:bg-white/10"
        }`}
      >
        <Icon size={24} />
        <span className="flex flex-col text-left leading-none">
          <span
            className={`text-[10px] uppercase tracking-wide ${
              variant === "light" ? "text-slate-500" : "text-slate-400"
            }`}
          >
            {caption}
          </span>
          <span className="mt-1 text-base font-semibold">{store}</span>
        </span>
      </a>
    ))}
  </div>
);

export default StoreButtons;
